import { instance as axios, setJwtToken } from "../../config/axiosInstance";

export const getPowerCustomers = async ({ startDate, endDate }) => {
  const response = await axios.get(
    `/admin/power-customers?${new URLSearchParams({ startDate, endDate }).toString()}`,
    setJwtToken()
  );
  if (!response.data?.success) {
    throw new Error(response.data?.message || "Unable to load power customers");
  }
  return response.data.result;
};

export const updatePowerCustomerTags = async (userId, tags) => {
  const response = await axios.put(
    `/admin/power-customers/${userId}/tags`,
    { tags },
    setJwtToken()
  );
  if (!response.data?.success) {
    throw new Error(response.data?.message || "Unable to update tags");
  }
  return response.data.result;
};
